export function isValidRegex(input: string): boolean {
  let isValid = true
  try {
    new RegExp(input)
  } catch (e) {
    isValid = false
  }
  return isValid
}
